import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerStore } from '../../../services/api/banner/banner-store.service';
import { LanguagePipe } from '../../../pipes/language/language.pipe';
import { LoadingAnimationComponent } from '../../feedback/loading-animation/loading-animation.component';
import { ToFontSizePipe } from '../../../pipes/to-font-size/to-font-size.pipe';
import { FilterTextsPipe } from '../../../pipes/filterTexts/filterTexts.pipe';
import { EEntityType, ERelationType } from '@web/dtos';

@Component({
  selector: 'aw-banner',
  imports: [
    CommonModule,
    LanguagePipe,
    LoadingAnimationComponent,
    ToFontSizePipe,
    FilterTextsPipe,
  ],
  templateUrl: './banner.component.html',
  styles: ``,
})
export class BannerComponent {
  protected readonly bannerStore: BannerStore = inject(BannerStore);
  protected readonly RelationType: typeof ERelationType = ERelationType;
  protected readonly EEntityType: typeof EEntityType = EEntityType;
}
